import { PopoverGroupOptionsMixin } from 'trunks/vue/admin/components/popover_group_options.js';

export default Vue.extend({
  mixins: [PopoverGroupOptionsMixin],

  template: `
    <popover-group-options optionsFilterPlaceholder='搜索分组'
                           :initialSelectedOptionIds='parsedInitialSelectedOptionIds'
                           optionsUrl='/message_groups'
                           :formatDataFunc='formatMessageGroups'
                           ref='popoverGroupOptionsRef'
                           @cancelClicked='cancelFunc'
                           @submitClicked='submitFunc'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <div class='tip gray-text'>
          <i :class='option.icon'></i>
        </div>
        <div class='content'>
          <span>{{ option.name }}</span>
        </div>
        <i class='tip primary-text' :class="option._selected ? 'slp-check-circle' : 'slp-empty'"></i>
      </template>

      <div slot='filter-blankslate' class='list-group'>
        <div class="list-group-name">没有相关的搜索结果</div>
      </div>

      <div slot='options-blankslate' class='list-group'>
        <div class="list-group-name">没有“分组”</div>
      </div>
    </popover-group-options>
  `,

  props: {
    initialSelectedOptionIds: {
      type: Array,
    },
  },

  data() {
    return {
      parsedInitialSelectedOptionIds: _.map(this.initialSelectedOptionIds, (id) => parseInt(id)),
    };
  },

  methods: {
    formatMessageGroups(data = []) {
      data.unshift(_.clone(_cargo.message_group.subscribed));
      return [{ id: Skylark.Helpers.Utilities.uuid(), options: data }];
    },
  },
});
